import moment from "moment"

export function formatMaintenanceTime(iso?: string | null) {
  if (!iso) return ""
  const m = moment(iso)
  return m.isValid() ? m.format("lll") : iso
}
